import React, { useEffect, useState } from 'react'
import './App.css'
import './EditEvent.css'
import { Link, Redirect, useHistory, useLocation } from 'react-router-dom'
import Axios from 'axios'
import { createPortal } from 'react-dom'
import ClipLoader from 'react-spinners/ClipLoader'
import TopBarProgress from 'react-topbar-progress-indicator'
import { BiMenu } from 'react-icons/bi'
import {
  IoAdd,
  IoAnalyticsOutline,
  IoCalendarOutline,
  IoCheckmark,
  IoChevronBack,
  IoChevronForward,
  IoCloseCircleOutline,
  IoCloudDownloadOutline,
  IoImageOutline,
  IoLocationOutline,
  IoPauseOutline,
  IoPencilOutline,
  IoPeopleOutline,
  IoPlayOutline,
  IoReceiptOutline,
  IoStar,
  IoTicketOutline,
  IoTimeOutline,
  IoTrashOutline,
  IoWalletOutline,
  IoRocketOutline,
  IoSearchOutline,
} from 'react-icons/io5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import { API_URL } from './config'

const REASONS = [
  { value: 'covid-19 restrictions', label: 'Covid-19 restrictions' },
  { value: 'venue cancelled', label: 'Venue cancelled' },
  { value: 'sponsor pulls out', label: 'Sponsor pulls out' },
  { value: 'unfavorable weather conditions', label: 'Unfavorable weather conditions' },
  { value: 'missing paperwork', label: 'Missing paperwork' },
  { value: 'competing events', label: 'Competing events' },
  { value: 'other', label: 'Other' },
]

const STATUS_LABELS = {
  scheduled: 'Scheduled',
  ended: 'Ended',
  postponed: 'Postponed',
  cancelled: 'Cancelled',
  deleted: 'Deleted',
}

const Dialog = ({ open, onClose, size = 'md', children }) => {
  useEffect(() => {
    if (!open) return undefined
    const onKey = (e) => e.key === 'Escape' && onClose()
    document.addEventListener('keydown', onKey)
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prev
    }
  }, [open, onClose])

  if (!open) return null
  return createPortal(
    <div className="ee-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`ee-sheet ee-sheet-${size}`} role="dialog" aria-modal="true">
        {children}
      </div>
    </div>,
    document.body,
  )
}

function formatToZAR(amount) {
  return new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' })
    .format(Number(amount) || 0)
    .replace(/\s/g, '')
}

const Row = ({ icon, title, hint, right, locked, danger }) => (
  <>
    <span className={`ee-row-icon ${danger ? 'is-danger' : ''}`}>{icon}</span>
    <span className="ee-row-text">
      <span className={`ee-row-title ${danger ? 'is-danger' : ''}`}>{title}</span>
      {hint && <span className="ee-row-hint">{hint}</span>}
    </span>
    {right}
    {!right && !locked && <IoChevronForward className="ee-row-chev" />}
  </>
)

const Editevent = (props) => {
  const history = useHistory()
  const baseURL = `${API_URL}/apps/kscanner/webservices.php`
  const location = useLocation()
  const preimageState = location.state?.poster || null

  const [count, setCount] = useState(0)
  const [actionBtn, setActionBtn] = useState('Postpone')
  const [showModal, setShowModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [controlModal, setControlModal] = useState(false)
  const [addPoster, setAddPoster] = useState(false)
  const [postponeEvent, setPostponeEvent] = useState(false)
  const [resumeModal, setResumeModal] = useState(false)
  const [getVVIP, setGetVVIP] = useState('')
  const [getVVIPprice, setGetVVIPprice] = useState(0)
  const [getVIPprice, setGetVIPprice] = useState(0)
  const [getGENprice, setGetGENprice] = useState(0)
  const [getVIP, setGetVIP] = useState('')
  const [getGen, setGetGen] = useState('')
  const [currentSelect, setCurrentSelect] = useState('VVIP')
  const [selectedPrice, setSelectedPrice] = useState(0)
  const [selectedTicket, setSelectedTicket] = useState(0)
  const [kidsSelectedPrice, setKidsSelectedPrice] = useState(0)
  const [kidsSelectedTicket, setKidsSelectedTicket] = useState(0)
  const [spinning, setSpinning] = useState('none')
  const [updateDisplay, setUpdateDisplay] = useState('block')
  const [error, setError] = useState('')
  const [successError, setSuccessError] = useState('')
  const [deletion, setDeletion] = useState(null) // { tone, text }
  const [deleted, setDeleted] = useState(0)
  const [image, setImage] = useState(null)
  const [numberOfcustomers, setNumberOfcustomers] = useState(0)
  const [message, setMessage] = useState('')
  const [reason, setReason] = useState('')
  const [subtype, setSubtype] = useState('postpone')
  const [hideUploadBtn, setHideUploadBtn] = useState('none')
  const [checktickets, setChecktickets] = useState('no')
  const [checkcampaign, setCheckcampaign] = useState('no')
  const [checkposter, setCheckposter] = useState('no')
  const [loadBarProgress, setLoadBarProgress] = useState(false)
  const [ticketCount, setTicketCount] = useState(0)
  const [kids_vip_tickets, setKidsVipTickets] = useState(0)
  const [kids_general_tickets, setKidsGeneralTickets] = useState(0)
  const [kids_vip_price, setKidsVipPrice] = useState(0)
  const [kids_general_price, setKidsGeneralPrice] = useState(0)
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [imgname, setImgname] = useState('')
  const [preimage, setPreimage] = useState(preimageState)
  const [delString, setDelString] = useState(null)
  const [kids_price, setKidsPrice] = useState(0)
  const [kids_tickets, setKidsTickets] = useState(0)
  const [checkCampaignStatus, setCheckCampaignStatus] = useState('stop')
  const [cancelTitle, setCancelTitle] = useState('Cancel')
  const [cancelledAt, setCancelledAt] = useState(null)
  const [sales, setSales] = useState({ complete: 0, pending: 0, refunds: 0 })
  const [txns, setTxns] = useState([])
  const [txLoaded, setTxLoaded] = useState(false)
  const [txModal, setTxModal] = useState(false)
  const [txFilter, setTxFilter] = useState('ALL')
  const [txPage, setTxPage] = useState(1)
  const [txSearch, setTxSearch] = useState('')
  const [txFrom, setTxFrom] = useState('')
  const [txTo, setTxTo] = useState('')
  const txPerPage = 10

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState(isMobile)
  const [collapsed, setCollapsed] = useState(isMobile)

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  const {
    eventname,
    eventdate,
    eventid,
    poster,
    theme,
    venue,
    expectednum,
    enddate,
    time,
    endtime,
    event_date,
    finish_date,
    campaignstatus,
    is_sponsorship,
    prevpage,
  } = location.state || {}

  useEffect(() => {
    const businessname = localStorage.getItem('businessname')
    const businessid = localStorage.getItem('businessid')
    document.title = `${eventname} - ${businessname}`

    const date = new Date()
    const fulldate = date.toISOString().split('T')[0] // YYYY-MM-DD

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=REPRINTABLETICKETS&eventid=${eventid}`,
      {
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.val === 0 || res.data.ticketCount === 0) {
        setTicketCount(0)
      } else {
        setTicketCount(res.data.ticketCount)
      }
    })

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=CHECKCAMPAIGN&eventid=${eventid}`, {
      withCredentials: true,
    }).then((res) => {
      if (res.data.thumbnail === 'yes') {
        setPreimage(
          `${API_URL}/apps/kscanner/posters/${res.data.businessid}/${res.data.eventid}/${res.data.image}`,
        )
      }
      setCheckcampaign(res.data.checkcampaign)
      setCheckposter(res.data.thumbnail)
    })

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=CHECKTICKETS&eventid=${eventid}`, {
      withCredentials: true,
    }).then((res) => setChecktickets(res.data.tickets))

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=EVENTSALESDATA&eventid=${eventid}`, {
      withCredentials: true,
    }).then((res) => setNumberOfcustomers(res.data.numberOfcustomers))

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CHECKIFEVENTDELETED&eventid=${eventid}`,
      {
        withCredentials: true,
      },
    ).then((res) => {
      const deletionStatus = res.data.deletion
      const eventDay = res.data.event_day
      const postponed_at = res.data.postponed_at
      const cancelled_at = res.data.cancelled_at
      const updated_at = res.data.updated_at

      setCancelledAt(cancelled_at)

      let next
      if (cancelled_at != null || postponed_at != null) {
        next = {
          tone: postponed_at != null ? 'postponed' : 'cancelled',
          text: `This event was officially ${
            postponed_at != null ? 'postponed' : 'cancelled'
          } on ${updated_at}. All associated ticket holders have been notified.`,
        }
      } else if (eventDay < fulldate) {
        next = { tone: 'ended', text: `This event concluded on ${eventdate}.` }
      } else if (deletionStatus === 1) {
        next = { tone: 'deleted', text: 'This event has been deleted.' }
      } else {
        next = { tone: 'scheduled', text: `This event is scheduled to take place on ${eventdate}.` }
      }

      setDeleted(deletionStatus)
      setDeletion(next)
    })

    // Check campaign status for current event
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GET-CAMPAIGN-STATUS&eventid=${eventid}`,
      {
        withCredentials: true,
      },
    ).then((res) => {
      setCheckCampaignStatus(res.data.campaign_status ?? 'stop')
    })

    // Fetch VVIP ticket details
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETVVIPDETAILS&accountid=${businessid}&eventid=${eventid}`,
      { withCredentials: true },
    ).then((res) => {
      setGetVVIP(res.data.vvipticketavail ?? 0)
      setGetVVIPprice(res.data.vvipprice ?? 0)
      setKidsPrice(res.data.kids_vvip_price ?? 0)
      setKidsTickets(res.data.kids_vvip_tickets ?? 0)

      setSelectedTicket(0)
      setSelectedPrice(res.data.genprice ?? res.data.vvipprice)
      setKidsSelectedPrice(res.data.kids_price ?? res.data.kids_vvip_price)
      setKidsSelectedTicket(0)
    })

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETVIPDETAILS&accountid=${businessid}&eventid=${eventid}`,
      { withCredentials: true },
    ).then((res) => {
      setGetVIP(res.data.vipticketavail ?? 0)
      setGetVIPprice(res.data.vipprice ?? 0)
      setKidsVipPrice(res.data.kids_vip_price ?? 0)
      setKidsVipTickets(res.data.kids_vip_tickets ?? 0)
    })

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETGENDETAILS&accountid=${businessid}&eventid=${eventid}`,
      { withCredentials: true },
    ).then((res) => {
      setGetGen(res.data.genticketavail ?? 0)
      setGetGENprice(res.data.genprice ?? 0)
      setKidsGeneralPrice(res.data.kids_general_price ?? 0)
      setKidsGeneralTickets(res.data.kids_general_tickets ?? 0)
    })

    // Sales snapshot + recent transactions for this event
    Axios.get(`${baseURL}?query=TRANSACTION-AMOUNTS&event_id=${eventid}`, {
      withCredentials: true,
    })
      .then((res) =>
        setSales({
          complete: res.data.completedAmount,
          pending: res.data.pendingAmount,
          refunds: res.data.refundedAmt,
        }),
      )
      .catch((err) => console.error('Error fetching sales:', err))

    Axios.get(`${baseURL}?query=TRANSACTIONS-LIST&event_id=${eventid}`, {
      withCredentials: true,
    })
      .then((res) => {
        setTxns(res.data.status === 'success' ? res.data.transactions : [])
        setTxLoaded(true)
      })
      .catch(() => {
        setTxns([])
        setTxLoaded(true)
      })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [count, eventid, eventname, event_date, deleted, checkcampaign, checkposter, checktickets])

  const reprint = () => {
    const eventid = props.location.state.eventid
    const eventname = props.location.state.eventname
    localStorage.setItem('eventid', eventid)
    localStorage.setItem('eventname', eventname)
    history.push({
      pathname: '/download',
      state: {
        reprint: 'yes',
      },
    })
  }

  const closeModal = () => {
    setShowModal(false)
    setDeleteModal(false)
    setAddPoster(false)
    setControlModal(false)
    setPostponeEvent(false)
    setResumeModal(false)
    setErrorDisplay('none')
  }

  const openModal = () => {
    setShowModal(true)
    setCancelTitle('Cancel')
  }

  const delModal = () => {
    setDeleteModal(true)
  }

  const addAPoster = () => {
    setAddPoster(true)
  }

  const activateVVIP = () => {
    setCurrentSelect('VVIP')
    setSelectedTicket(0)
    setSelectedPrice(getVVIPprice)
    setKidsSelectedPrice(kids_price)
    setKidsSelectedTicket(0)
  }

  const activateGen = () => {
    setCurrentSelect('General')
    setSelectedTicket(0)
    setSelectedPrice(getGENprice)
    setKidsSelectedPrice(kids_general_price)
    setKidsSelectedTicket(0)
  }

  const activateVIP = () => {
    setCurrentSelect('VIP')
    setSelectedTicket(0)
    setSelectedPrice(Number(getVIPprice))
    setKidsSelectedPrice(Number(kids_vip_price))
    setKidsSelectedTicket(0)
  }

  const handleTickets = (event) => {
    setSelectedTicket(event.target.value)
    setErrorDisplay('none')
  }

  const handlePrice = (event) => {
    setSelectedPrice(event.target.value)
    setErrorDisplay('none')
  }

  const handle_kids_tickets = (event) => {
    setKidsSelectedTicket(event.target.value)
    setErrorDisplay('none')
  }

  const handle_kids_price = (event) => {
    setKidsSelectedPrice(event.target.value)
    setErrorDisplay('none')
  }

  const cancel = () => {
    setShowModal(false)
    setDeleteModal(false)
    setControlModal(false)
    setResumeModal(false)
    setErrorDisplay('none')
  }

  const failUpdate = (msg) => {
    setError(msg)
    setErrorDisplay('block')
    setSuccessError('error-login')
    setUpdateDisplay('block')
    setSpinning('none')
  }

  const update = async () => {
    const { eventid } = location.state || {}

    const price = selectedPrice
    const numberOftickets = selectedTicket
    const kidsPrice = kidsSelectedPrice
    const kidsTickets = kidsSelectedTicket
    const category = currentSelect.toLowerCase()

    if (numberOftickets > 0 && (price <= 0 || price === '')) {
      failUpdate('Ticket price cannot be empty or R0.0 for Adults')
    } else if (numberOftickets > 0 && isNaN(price)) {
      failUpdate('Invalid ticket price for Adults.')
    } else if (kidsTickets > 0 && (kidsPrice <= 0 || kidsPrice === '')) {
      failUpdate('Ticket price cannot be empty or R0.0 for Kids.')
    } else if (kidsTickets > 0 && isNaN(kidsPrice)) {
      failUpdate('Invalid ticket price, please enter a number for Kids.')
    } else {
      setUpdateDisplay('none')
      setSpinning('block')
      setLoadBarProgress(true)

      const dataForm = new FormData()

      dataForm.append('price', price)
      dataForm.append('numberOftickets', numberOftickets)
      dataForm.append('category', category)
      dataForm.append('eventid', eventid)
      dataForm.append('kids_price', kidsPrice)
      dataForm.append('kids_tickets', kidsTickets)
      dataForm.append('query', 'ADDTICEKTS')

      await Axios({
        method: 'POST',
        url: baseURL,
        data: dataForm,
        withCredentials: true,
      })
        .then((response) => {
          setCount(count + 1)
          if (response.data.status === 'failed') {
            setError(response.data.error)
            setErrorDisplay('block')
            setSuccessError('error-login')
            setUpdateDisplay('block')
            setSpinning('none')
            setLoadBarProgress(false)

            setTimeout(() => {
              setErrorDisplay('none')
            }, 5000)
          } else {
            setError(response.data.message)
            setErrorDisplay('block')
            setSuccessError(response.data.status == 'warning' ? 'warning-bg' : 'success-login')
            setUpdateDisplay('block')
            setSpinning('none')
            setChecktickets('yes')

            setLoadBarProgress(false)
            setCancelTitle('Done')
            setDeleteModal(false)
            setAddPoster(false)
            setControlModal(false)
            setPostponeEvent(false)
            setResumeModal(false)

            setTimeout(() => {
              setErrorDisplay('none')
            }, 5000)
          }
        })
        .catch(() => {
          setLoadBarProgress(false)
          failUpdate("We couldn't load your tickets. Please check your connection and try again.")
        })
    }

    setTimeout(() => {
      setErrorDisplay('none')
    }, 4000)
  }

  const deleteEvent = () => {
    const { eventid } = location.state || {}
    const data = new FormData()
    data.append('eventid', eventid)
    data.append('query', 'DELETEEVENT')

    Axios({
      method: 'POST',
      url: baseURL,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.status === 'success') {
          history.goBack()
        } else {
          setError(response.data.message || 'Something went wrong.')
          setErrorDisplay('block')
          setSuccessError('error-login')
          setUpdateDisplay('block')
          setSpinning('none')
        }
      })
      .catch((error) => {
        const message =
          error.response?.data?.message ||
          "We couldn't complete your request. Please check your connection or try again shortly."
        setError(message)
        setErrorDisplay('block')
        setSuccessError('error-login')
        setUpdateDisplay('block')
        setSpinning('none')
      })

    setTimeout(() => {
      setUpdateDisplay('none')
    }, 5000)
  }

  const functionControl = () => {
    if (checkcampaign == 'no') {
      setControlModal(true)
      setDelString('You have to create a campaign first')
    } else if (deleted == 1) {
      setControlModal(true)
      setDelString("This event has been deleted, it can't be edited")
    } else {
      setControlModal(true)
      setDelString("This event has already passed, it can't be edited")
    }
  }

  const campaign = () => {
    const s = props.location.state
    history.push({
      pathname: 'campaign',
      state: {
        eventid: s.eventid,
        eventname: s.eventname,
        poster: s.poster,
        eventdate: s.eventdate,
        enddate: s.enddate,
        event_date: s.event_date,
        finish_date: s.finish_date,
        theme: s.theme,
        venue: s.venue,
        expectednum: s.expectednum,
        time: s.time,
        endtime: s.endtime,
        prevpage: s.prevpage,
        currentpage: 'editevent',
      },
    })
  }

  const selectImage = (event) => {
    const img = event.target.files[0]
    if (!img) return
    const previewURL = URL.createObjectURL(img)

    setImage(previewURL)
    setPreimage(previewURL)
    setImgname(img)
    setHideUploadBtn('block')
  }

  const uploadPoster = async () => {
    const eventid = props.location.state.eventid
    const accountid = localStorage.getItem('businessid')
    let data = new FormData()
    setUpdateDisplay('none')
    setSpinning('block')

    data.append('file', imgname)
    data.append('eventid', eventid)
    data.append('businessid', accountid)
    data.append('query', 'POSTERUPLOAD')

    if (image === '') {
      setError('Please select a poster')
      setErrorDisplay('block')
      setSuccessError('error-login')
      setUpdateDisplay('block')
      setSpinning('none')
    } else {
      await Axios({
        url: `${API_URL}/apps/kscanner/webservices.php`,
        method: 'POST',
        data: data,
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then((response) => {
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError(response.data.status === 'success' ? 'success-alert' : 'error-alert')
          setUpdateDisplay('block')
          setSpinning('none')
          setAddPoster(false)
          setCheckposter('yes')
          setLoadBarProgress(false)
          setShowModal(false)
          setDeleteModal(false)
          setControlModal(false)
          setPostponeEvent(false)
          setResumeModal(false)
        })
        .catch((error) => {
          console.log('image upload error: ', error)
          setUpdateDisplay('block')
          setSpinning('none')
          setLoadBarProgress(false)
          setError("We couldn't upload the poster. Please try again.")
          setErrorDisplay('block')
          setSuccessError('error-login')
        })

      setTimeout(() => {
        setErrorDisplay('none')
      }, 4000)

      history.push({
        pathname: '/editevent',
        state: {
          campaignstatus,
          eventid,
          eventname,
          poster,
          eventdate,
          enddate,
          event_date,
          finish_date,
          theme,
          venue,
          expectednum,
          time,
          endtime,
          prevpage,
        },
      })
    }
  }

  const postpone = () => {
    setPostponeEvent(true)
    setSubtype('postpone')
    setActionBtn('Confirm Postponement')
  }

  const cancelModal = () => {
    setPostponeEvent(true)
    setSubtype('cancel')
    setActionBtn('Confirm Cancellation')
  }

  const handleMessage = (event) => {
    setMessage(event.target.value)
    setErrorDisplay('none')
  }

  const postponeTheEvent = () => {
    const eventid = props.location.state.eventid
    const businessid = localStorage.getItem('businessid')
    const type = subtype

    if (reason === '') {
      setError('Select a reason for the postponement ')
      setErrorDisplay('block')
      setSuccessError('error-login')
    } else if (message.trim() === '') {
      setError('Write a message ')
      setErrorDisplay('block')
      setSuccessError('error-login')
    } else {
      setSpinning('block')
      const data = new FormData()
      data.append('query', 'POSTPONE')
      data.append('businessid', businessid)
      data.append('eventid', eventid)
      data.append('type', type)
      data.append('message', message)
      data.append('reason', reason)

      Axios.post(`${API_URL}/apps/kscanner/webservices.php`, data, {
        withCredentials: true,
      })
        .then((response) => {
          if (response.data.status === 'success') {
            setCount(count + 1)
            setError(response.data.message)
            setErrorDisplay('block')
            setSuccessError('success-login')

            setShowModal(false)
            setDeleteModal(false)
            setPostponeEvent(false)
          } else {
            setError(response.data.message)
            setErrorDisplay('block')
            setSuccessError('error-login')
          }

          setTimeout(() => {
            setErrorDisplay('none')
          }, 6000)
          setSpinning('none')
        })
        .catch((err) => {
          setError(err)
          setErrorDisplay('block')
          setSuccessError('error-login')

          setTimeout(() => {
            setErrorDisplay('none')
          }, 6000)
          setSpinning('none')
        })
    }
  }

  const resumeAModal = () => {
    setResumeModal(true)
  }

  const resumeCampaign = () => {
    const eventid = props.location.state.eventid
    const accountid = localStorage.getItem('businessid')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=RESUMECAMPAIGN&eventid=${eventid}&businessid=${accountid}`,
      { withCredentials: true },
    )
      .then((response) => {
        if (response.data.status === 'failed') {
          setResumeModal(false)
          setCount(count + 1)
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError('error-login')
        } else {
          setResumeModal(false)
          setCount(count + 1)
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError(response.data.status === 'stop' ? 'error-login' : 'success-login')
        }
      })
      .catch((error) => {
        setError(error)
        setErrorDisplay('block')
        setSuccessError('error-login')
      })

    setTimeout(() => {
      setErrorDisplay('none')
    }, 4000)
  }

  const downloadTickets = () => {
    const s = props.location.state
    localStorage.setItem('eventname', s.eventname)
    localStorage.setItem('download', 'download')
    localStorage.setItem('eventid', s.eventid)
    history.push({
      pathname: '/downloadtickets',
      state: {
        eventid: s.eventid,
        eventname: s.eventname,
        poster: s.poster,
        eventdate: s.eventdate,
        enddate: s.enddate,
        event_date: s.event_date,
        finish_date: s.finish_date,
        theme: s.theme,
        venue: s.venue,
        expectednum: s.expectednum,
        time: s.time,
        endtime: s.endtime,
        prevpage: s.prevpage,
        currentpage: 'editevent',
      },
    })
  }

  if (localStorage.getItem('businessid') === null) {
    return <Redirect to="/login" />
  }

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  // ---- derived state ----
  const fulldate = new Date().toLocaleDateString('en-CA') // YYYY-MM-DD, local time
  const isLive = event_date >= fulldate && deleted == 0
  const ticketsReady = checktickets === 'yes'
  const posterReady = checkposter === 'yes'
  const canDownload = isLive && ticketsReady && posterReady && checkcampaign === 'yes'
  const cancelledOrPostponed = cancelledAt != null
  const paused = checkCampaignStatus === 'stop'
  const notPublished = checkcampaign === 'no'
  const statusString = paused ? 'Resume campaign' : 'Pause campaign'
  const busy = spinning === 'block'
  const hasPoster = preimage && preimage !== 'none'
  const toastType = String(successError).includes('error')
    ? 'error'
    : String(successError).includes('warning')
      ? 'warning'
      : 'success'

  const steps = [
    {
      key: 'tickets',
      title: 'Load tickets',
      hint: ticketsReady ? 'Tickets are loaded. Top up any time.' : 'Set prices and quantities',
      done: ticketsReady,
      icon: <IoTicketOutline />,
      onClick: isLive ? openModal : functionControl,
    },
    {
      key: 'poster',
      title: 'Upload poster',
      hint: posterReady ? 'Poster is uploaded' : 'Add the poster buyers will see',
      done: posterReady,
      icon: <IoImageOutline />,
      onClick: isLive ? addAPoster : functionControl,
    },
    {
      key: 'publish',
      title: 'Publish event',
      hint: notPublished ? 'Create a campaign to go live' : 'Campaign created',
      done: !notPublished,
      icon: <IoRocketOutline />,
      onClick: isLive && ticketsReady && posterReady ? campaign : functionControl,
    },
    {
      key: 'download',
      title: 'Download tickets',
      hint: ticketCount > 0 ? 'Tickets downloaded' : 'Get your printable tickets',
      done: ticketCount > 0,
      icon: <IoCloudDownloadOutline />,
      onClick: canDownload ? downloadTickets : functionControl,
    },
  ]
  const doneCount = steps.filter((s) => s.done).length

  const completeTxns = txns.filter((t) => t.payment_status.toLowerCase() === 'complete')
  const admissionsTotal = completeTxns.reduce((sum, t) => sum + (Number(t.admissions) || 0), 0)
  const sortedTxns = [...txns].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
  const recentTxns = sortedTxns.slice(0, 5)
  const txQuery = txSearch.trim().toLowerCase()
  const filteredTxns = sortedTxns.filter((t) => {
    if (txFilter !== 'ALL' && t.payment_status.toUpperCase() !== txFilter) return false
    const d = String(t.created_at || '').slice(0, 10)
    if (txFrom && d < txFrom) return false
    if (txTo && d > txTo) return false
    if (
      txQuery &&
      ![t.name_first, t.transaction_id, t.ticket_type].some((v) =>
        String(v ?? '')
          .toLowerCase()
          .includes(txQuery),
      )
    )
      return false
    return true
  })
  const txFiltersActive = txFilter !== 'ALL' || txFrom || txTo || txQuery
  const filteredCompleteTotal = filteredTxns
    .filter((t) => t.payment_status.toLowerCase() === 'complete')
    .reduce((sum, t) => sum + (Number(t.amount_gross) || 0), 0)
  const clearTxFilters = () => {
    setTxSearch('')
    setTxFrom('')
    setTxTo('')
    setTxFilter('ALL')
    setTxPage(1)
  }
  const txPages = Math.max(1, Math.ceil(filteredTxns.length / txPerPage))
  const pagedTxns = filteredTxns.slice((txPage - 1) * txPerPage, txPage * txPerPage)

  const routeState = {
    campaignstatus,
    eventid,
    eventname,
    poster,
    eventdate,
    enddate,
    event_date,
    finish_date,
    theme,
    venue,
    expectednum,
    time,
    endtime,
    prevpage,
  }

  const tiers = [
    {
      name: 'VVIP',
      onSelect: activateVVIP,
      adults: `${getVVIP} loaded · R${getVVIPprice}`,
      kids: `${kids_tickets} loaded · R${kids_price}`,
    },
    {
      name: 'VIP',
      onSelect: activateVIP,
      adults: `${getVIP} loaded · R${getVIPprice}`,
      kids: `${kids_vip_tickets} loaded · R${kids_vip_price}`,
    },
    {
      name: 'General',
      onSelect: activateGen,
      adults: `${getGen} loaded · R${getGENprice}`,
      kids: `${kids_general_tickets} loaded · R${kids_general_price}`,
    },
  ]

  return (
    <div className="view">
      {loadBarProgress && <TopBarProgress />}
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />

      <div
        className="main-content ee-page"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMob ? '0px' : collapsed ? '76px' : '252px',
        }}
      >
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}
        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        {/* ---------- Top bar ---------- */}
        <div className="ee-topbar">
          <button type="button" className="ee-back" onClick={() => history.goBack()}>
            <IoChevronBack size={18} /> Back
          </button>

          {!cancelledOrPostponed && (
            <Link
              className="ee-btn ee-btn-ghost"
              to={{
                pathname: 'updateeventdetails',
                state: { ...routeState, currentage: 'editevent' },
              }}
            >
              <IoPencilOutline size={16} /> Edit details
            </Link>
          )}
        </div>

        {is_sponsorship == true && (
          <div className="ee-sponsor">
            <IoStar /> Tickets to this event are proudly sponsored by Karamale.
          </div>
        )}

        <div className="ee-grid">
          {/* ---------- Main column ---------- */}
          <div className="ee-main">
            <section className="ee-card ee-event">
              <div className="ee-poster">
                {hasPoster ? (
                  <img src={preimage} alt={eventname} />
                ) : (
                  <button
                    type="button"
                    className="ee-poster-empty"
                    onClick={isLive ? addAPoster : functionControl}
                  >
                    <IoImageOutline size={34} />
                    <span>No poster yet</span>
                    {isLive && <small>Click to upload</small>}
                  </button>
                )}
              </div>

              <div className="ee-event-body">
                {deletion && (
                  <span className={`ee-chip ee-chip-${deletion.tone}`}>
                    {STATUS_LABELS[deletion.tone]}
                  </span>
                )}
                <h1 className="ee-title">{eventname}</h1>
                {deletion && (
                  <p className={`ee-status-text ee-tone-${deletion.tone}`}>{deletion.text}</p>
                )}

                <dl className="ee-meta">
                  {eventdate && (
                    <div>
                      <dt>
                        <IoCalendarOutline /> Date
                      </dt>
                      <dd>
                        {eventdate}
                        {enddate && enddate !== eventdate ? ` to ${enddate}` : ''}
                      </dd>
                    </div>
                  )}
                  {time && (
                    <div>
                      <dt>
                        <IoTimeOutline /> Time
                      </dt>
                      <dd>
                        {time}
                        {endtime ? ` to ${endtime}` : ''}
                      </dd>
                    </div>
                  )}
                  {venue && (
                    <div>
                      <dt>
                        <IoLocationOutline /> Venue
                      </dt>
                      <dd>{venue}</dd>
                    </div>
                  )}
                  {expectednum && (
                    <div>
                      <dt>
                        <IoPeopleOutline /> Expected
                      </dt>
                      <dd>{expectednum}</dd>
                    </div>
                  )}
                </dl>
              </div>
            </section>

            <section className="ee-card">
              <div className="ee-card-head">
                <h2>Sales</h2>
              </div>
              <dl className="ee-sales">
                <div>
                  <dt>Completed</dt>
                  <dd>{formatToZAR(sales.complete)}</dd>
                </div>
                <div>
                  <dt>Transactions</dt>
                  <dd>{completeTxns.length}</dd>
                </div>
                <div>
                  <dt>Admissions</dt>
                  <dd>{admissionsTotal}</dd>
                </div>
                <div>
                  <dt>Pending</dt>
                  <dd>{formatToZAR(sales.pending)}</dd>
                </div>
                <div>
                  <dt>Refunds</dt>
                  <dd>{formatToZAR(sales.refunds)}</dd>
                </div>
              </dl>
            </section>

            <section className="ee-card">
              <div className="ee-card-head">
                <h2>Tickets</h2>
                {ticketsReady && isLive && (
                  <button type="button" className="ee-linkbtn" onClick={openModal}>
                    Top up
                  </button>
                )}
              </div>
              {ticketsReady ? (
                <div className="ee-table-scroll">
                  <table className="ee-table">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Adults</th>
                        <th>Kids</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tiers.map((t) => (
                        <tr key={t.name}>
                          <td className="ee-strong">{t.name}</td>
                          <td>{t.adults}</td>
                          <td>{t.kids}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="ee-empty">
                  No tickets loaded yet.{' '}
                  {isLive && (
                    <button type="button" className="ee-linkbtn" onClick={openModal}>
                      Load tickets
                    </button>
                  )}
                </p>
              )}
            </section>

            <section className="ee-card">
              <div className="ee-card-head">
                <h2>Recent transactions</h2>
                {txns.length > 0 && (
                  <button type="button" className="ee-linkbtn" onClick={() => setTxModal(true)}>
                    View all ({txns.length})
                  </button>
                )}
              </div>
              {!txLoaded ? (
                <p className="ee-empty">
                  <ClipLoader size={18} color="grey" />
                </p>
              ) : recentTxns.length === 0 ? (
                <p className="ee-empty">No transactions yet. Sales will appear here.</p>
              ) : (
                <div className="ee-table-scroll">
                  <table className="ee-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Buyer</th>
                        <th>Type</th>
                        <th className="ee-r">Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentTxns.map((t) => (
                        <tr key={t.transaction_id}>
                          <td>{t.date ?? t.created_at}</td>
                          <td>{t.name_first}</td>
                          <td className="ee-cap">{t.ticket_type.toLowerCase()}</td>
                          <td className="ee-r ee-strong">{formatToZAR(t.amount_gross)}</td>
                          <td>
                            <span className={`ee-pill ee-pill-${t.payment_status.toLowerCase()}`}>
                              {t.payment_status.toLowerCase()}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </section>
          </div>

          {/* ---------- Side column ---------- */}
          <aside className="ee-side">
            <section className="ee-card ee-campaign">
              <div className="ee-campaign-info">
                <span
                  className={`ee-dot ${notPublished ? 'is-idle' : paused ? 'is-paused' : 'is-live'}`}
                />
                <div>
                  <strong>
                    {notPublished
                      ? 'Not published yet'
                      : paused
                        ? 'Campaign paused'
                        : 'Campaign live'}
                  </strong>
                  <p>
                    {notPublished
                      ? 'Buyers cannot see this event.'
                      : paused
                        ? 'The event is hidden from the public.'
                        : 'The event is visible to the public.'}
                  </p>
                </div>
              </div>
              <button
                type="button"
                className={`ee-btn ${paused ? 'ee-btn-primary' : 'ee-btn-ghost'}`}
                onClick={resumeAModal}
              >
                {paused ? <IoPlayOutline size={16} /> : <IoPauseOutline size={16} />} {statusString}
              </button>
            </section>

            {!cancelledOrPostponed && (
              <section className="ee-card">
                <div className="ee-card-head">
                  <h2>Get ready to sell</h2>
                  <span className="ee-count">
                    {doneCount} of {steps.length}
                  </span>
                </div>
                <div
                  className="ee-progress"
                  role="progressbar"
                  aria-valuemin={0}
                  aria-valuemax={steps.length}
                  aria-valuenow={doneCount}
                >
                  <span style={{ width: `${(doneCount / steps.length) * 100}%` }} />
                </div>

                <ol className="ee-steps">
                  {steps.map((s, i) => (
                    <li key={s.key}>
                      <button
                        type="button"
                        className={`ee-row ee-step ${s.done ? 'is-done' : ''} ${isLive ? '' : 'is-locked'}`}
                        onClick={s.onClick}
                      >
                        <span className="ee-step-mark">{s.done ? <IoCheckmark /> : i + 1}</span>
                        <span className="ee-row-text">
                          <span className="ee-row-title">{s.title}</span>
                          <span className="ee-row-hint">{s.hint}</span>
                        </span>
                        <IoChevronForward className="ee-row-chev" />
                      </button>
                    </li>
                  ))}
                </ol>

                {ticketCount > 0 && (
                  <button
                    type="button"
                    className={`ee-row ee-redownload ${canDownload ? '' : 'is-locked'}`}
                    onClick={canDownload ? reprint : functionControl}
                  >
                    <Row
                      icon={<IoCloudDownloadOutline />}
                      title="Re-download tickets"
                      right={<span className="ee-badge">{ticketCount}</span>}
                    />
                  </button>
                )}
              </section>
            )}

            <section className="ee-card ee-list">
              <Link
                className={`ee-row ${deleted == 0 ? '' : 'is-locked'}`}
                to={{ pathname: 'analytics', state: { ...routeState, back: 'editevent' } }}
              >
                <Row icon={<IoAnalyticsOutline />} title="Analytics" hint="Sales and attendance" />
              </Link>
              <Link
                className="ee-row"
                to={{
                  pathname: '/payout',
                  state: { eventid, eventname, is_sponsorship },
                }}
              >
                <Row icon={<IoWalletOutline />} title="Payout" hint="Earnings and withdrawals" />
              </Link>
              <Link
                className="ee-row"
                to={{
                  pathname: '/view-refund-request',
                  state: { eventid, eventname, is_sponsorship },
                }}
              >
                <Row
                  icon={<IoReceiptOutline />}
                  title="Refunds"
                  hint="Requests from ticket holders"
                />
              </Link>
            </section>

            <section className="ee-card ee-list ee-danger">
              <h2 className="ee-list-title">More actions</h2>
              {!cancelledOrPostponed && (
                <>
                  <button
                    type="button"
                    className={`ee-row ${isLive ? '' : 'is-locked'}`}
                    onClick={isLive ? postpone : functionControl}
                  >
                    <Row
                      icon={<IoCalendarOutline />}
                      title="Postpone event"
                      hint="Notify ticket holders of a new date"
                    />
                  </button>
                  <button
                    type="button"
                    className={`ee-row ${isLive ? '' : 'is-locked'}`}
                    onClick={isLive ? cancelModal : functionControl}
                  >
                    <Row
                      icon={<IoCloseCircleOutline />}
                      title="Cancel event"
                      hint="Final. Ticket holders are notified"
                    />
                  </button>
                </>
              )}
              <button
                type="button"
                className={`ee-row ${isLive ? '' : 'is-locked'}`}
                onClick={isLive ? delModal : functionControl}
              >
                <Row
                  danger
                  icon={<IoTrashOutline />}
                  title="Delete event"
                  hint="Permanent. Cannot be undone"
                />
              </button>
            </section>
          </aside>
        </div>
      </div>

      {/* ================= Modals ================= */}

      {/* Pause / resume campaign */}
      <Dialog open={resumeModal} onClose={closeModal}>
        <div className="ee-mb">
          <h3>{paused ? 'Resume campaign' : 'Pause campaign'}</h3>
          <p className="ee-mb-text">
            {paused
              ? 'Make your event live again. You can pause or update it any time.'
              : 'The event will be hidden from the public. You can resume any time.'}
          </p>
          <div className="ee-actions">
            <button type="button" className="ee-btn ee-btn-ghost" onClick={cancel}>
              Cancel
            </button>
            <button
              type="button"
              className={`ee-btn ${paused ? 'ee-btn-primary' : 'ee-btn-dark'}`}
              onClick={resumeCampaign}
            >
              {busy ? <ClipLoader color="#fff" size={16} /> : statusString}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Postpone / cancel */}
      <Dialog open={postponeEvent} onClose={closeModal}>
        <div className="ee-mb">
          <h3>
            {actionBtn === 'Confirm Cancellation' ? 'Cancel this event' : 'Postpone this event'}
          </h3>

          <label className="ee-field">
            <span>Reason</span>
            <select value={reason} onChange={(e) => setReason(e.target.value)} className="ee-input">
              <option value="">Select a reason</option>
              {REASONS.map((obj) => (
                <option key={obj.value} value={obj.value}>
                  {obj.label}
                </option>
              ))}
            </select>
          </label>

          <label className="ee-field">
            <span>Message to ticket holders</span>
            <textarea
              className="ee-input"
              rows={4}
              value={message}
              placeholder="Write a message (also propose a new date)"
              onChange={handleMessage}
            />
          </label>

          <p className="ee-note">
            {numberOfcustomers == 1
              ? '1 ticket holder will be notified.'
              : `${numberOfcustomers} ticket holders will be notified.`}
          </p>

          {actionBtn === 'Confirm Cancellation' && (
            <p className="ee-note ee-note-danger">
              This action is final. Once cancelled, the event cannot be reinstated.
            </p>
          )}

          <div className="ee-actions">
            <button
              type="button"
              className="ee-btn ee-btn-ghost"
              onClick={closeModal}
              disabled={busy}
            >
              Close
            </button>
            <button
              type="button"
              className={`ee-btn ${actionBtn === 'Confirm Cancellation' ? 'ee-btn-danger' : 'ee-btn-primary'}`}
              onClick={postponeTheEvent}
              disabled={busy}
            >
              {busy ? <ClipLoader color="#fff" size={16} /> : actionBtn}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Poster upload */}
      <Dialog open={addPoster} onClose={closeModal}>
        <div className="ee-mb">
          <h3>Upload poster</h3>
          <label
            className={`ee-drop ${image ? 'has-image' : ''}`}
            style={image ? { backgroundImage: `url(${image})` } : undefined}
          >
            {!image && (
              <span className="ee-drop-inner">
                <IoAdd size={30} />
                Click to select a poster
                <small>JPG, PNG, WEBP or GIF</small>
              </span>
            )}
            <input
              name="file"
              type="file"
              onChange={selectImage}
              id="image"
              accept=".jpg,.jpeg,.png,.webp,.gif"
              className="ee-file"
            />
          </label>
          <div className="ee-actions">
            <button type="button" className="ee-btn ee-btn-ghost" onClick={closeModal}>
              Close
            </button>
            <button
              type="button"
              className="ee-btn ee-btn-primary"
              style={{ display: hideUploadBtn }}
              onClick={uploadPoster}
              disabled={busy}
            >
              {busy ? (
                <ClipLoader color="#fff" size={16} />
              ) : (poster || '').trim() === '' ? (
                'Add poster'
              ) : (
                'Update poster'
              )}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Blocked-action explainer */}
      <Dialog open={controlModal} onClose={closeModal}>
        <div className="ee-mb">
          <h3>One thing first</h3>
          <p className="ee-mb-text">
            {checktickets == 'no' ? (
              <>
                You first have to{' '}
                <button
                  type="button"
                  className="ee-linkbtn"
                  onClick={() => {
                    setControlModal(false)
                    openModal()
                  }}
                >
                  load tickets
                </button>{' '}
                before you can do anything.
              </>
            ) : checkposter == 'no' ? (
              <>
                Now that tickets are loaded,{' '}
                <button
                  type="button"
                  className="ee-linkbtn"
                  onClick={() => {
                    setControlModal(false)
                    addAPoster()
                  }}
                >
                  upload a poster
                </button>{' '}
                and then create a campaign.
              </>
            ) : (
              delString
            )}
          </p>
          <div className="ee-actions">
            <button type="button" className="ee-btn ee-btn-ghost" onClick={cancel}>
              Close
            </button>
          </div>
        </div>
      </Dialog>

      {/* Delete */}
      <Dialog open={deleteModal} onClose={closeModal}>
        <div className="ee-mb">
          <h3>Delete this event?</h3>
          <p className="ee-mb-text">This action is permanent and cannot be undone.</p>
          <div className="ee-actions">
            <button type="button" className="ee-btn ee-btn-ghost" onClick={cancel}>
              Cancel
            </button>
            <button type="button" className="ee-btn ee-btn-danger" onClick={deleteEvent}>
              {busy ? <ClipLoader color="#fff" size={16} /> : 'Delete event'}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Load tickets */}
      <Dialog open={showModal} onClose={closeModal} size="lg">
        <div className="ee-mb">
          <h3>Load tickets</h3>
          <p className="ee-mb-text">
            Choose a ticket type, then set the price and how many to add.
          </p>

          <div className="ee-tiers" role="tablist">
            {tiers.map((t) => (
              <button
                key={t.name}
                type="button"
                role="tab"
                aria-selected={currentSelect === t.name}
                className={`ee-tier ${currentSelect === t.name ? 'is-active' : ''}`}
                onClick={t.onSelect}
              >
                <strong>{t.name}</strong>
                <span>Adults: {t.adults}</span>
                <span>Kids: {t.kids}</span>
              </button>
            ))}
          </div>

          <div className="ee-form-grid">
            <fieldset>
              <legend>Adults</legend>
              <label className="ee-field">
                <span>Ticket price (R)</span>
                <input
                  type="text"
                  inputMode="decimal"
                  placeholder="Price"
                  value={selectedPrice}
                  onChange={handlePrice}
                  className="ee-input"
                />
              </label>
              <label className="ee-field">
                <span>Add or top-up tickets</span>
                <input
                  type="text"
                  inputMode="numeric"
                  placeholder="Load tickets"
                  value={selectedTicket}
                  onChange={handleTickets}
                  className="ee-input"
                />
              </label>
            </fieldset>

            <fieldset>
              <legend>Kids</legend>
              <label className="ee-field">
                <span>Ticket price (R)</span>
                <input
                  type="text"
                  inputMode="decimal"
                  placeholder="Ticket price"
                  value={kidsSelectedPrice}
                  onChange={handle_kids_price}
                  className="ee-input"
                />
              </label>
              <label className="ee-field">
                <span>Add or top-up tickets</span>
                <input
                  type="text"
                  inputMode="numeric"
                  placeholder="Load tickets"
                  value={kidsSelectedTicket}
                  onChange={handle_kids_tickets}
                  className="ee-input"
                />
              </label>
            </fieldset>
          </div>

          <div className="ee-actions">
            <button type="button" className="ee-btn ee-btn-ghost" onClick={cancel}>
              {cancelTitle}
            </button>
            <button
              type="button"
              className="ee-btn ee-btn-primary"
              onClick={update}
              disabled={busy}
            >
              {busy ? <ClipLoader color="#fff" size={16} /> : `Load ${currentSelect} tickets`}
            </button>
          </div>
        </div>
      </Dialog>

      {/* All transactions */}
      <Dialog open={txModal} onClose={() => setTxModal(false)} size="xl">
        <div className="ee-mb ee-tx">
          <div className="ee-tx-head">
            <div>
              <h3>Transactions</h3>
              <p className="ee-mb-text ee-tight">
                {filteredTxns.length} {filteredTxns.length === 1 ? 'transaction' : 'transactions'}
                {txFiltersActive ? ` of ${txns.length}` : ''}
                {' · '}
                {formatToZAR(filteredCompleteTotal)} completed
                {eventname ? ` · ${eventname}` : ''}
              </p>
            </div>
          </div>

          <div className="ee-tx-tools">
            <div className="ee-search">
              <IoSearchOutline />
              <input
                type="search"
                className="ee-input"
                placeholder="Search buyer, ID or ticket type"
                value={txSearch}
                onChange={(e) => {
                  setTxSearch(e.target.value)
                  setTxPage(1)
                }}
              />
            </div>
            <label className="ee-tools-field">
              <span>From</span>
              <input
                type="date"
                className="ee-input"
                value={txFrom}
                max={txTo || undefined}
                onChange={(e) => {
                  setTxFrom(e.target.value)
                  setTxPage(1)
                }}
              />
            </label>
            <label className="ee-tools-field">
              <span>To</span>
              <input
                type="date"
                className="ee-input"
                value={txTo}
                min={txFrom || undefined}
                onChange={(e) => {
                  setTxTo(e.target.value)
                  setTxPage(1)
                }}
              />
            </label>
            <label className="ee-tools-field">
              <span>Status</span>
              <select
                className="ee-input"
                value={txFilter}
                onChange={(e) => {
                  setTxFilter(e.target.value)
                  setTxPage(1)
                }}
              >
                <option value="ALL">All</option>
                <option value="COMPLETE">Complete</option>
                <option value="PENDING">Pending</option>
                <option value="CANCELLED">Cancelled</option>
                <option value="ABANDONED">Abandoned</option>
              </select>
            </label>
            {txFiltersActive && (
              <button type="button" className="ee-btn ee-btn-ghost" onClick={clearTxFilters}>
                Clear
              </button>
            )}
          </div>

          <div className="ee-tx-body">
            <table className="ee-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Date</th>
                  <th>Buyer</th>
                  <th>Type</th>
                  <th className="ee-r">Admissions</th>
                  <th className="ee-r">Amount</th>
                  <th>Status</th>
                  <th>Refund status</th>
                  <th className="ee-r">Refunded</th>
                </tr>
              </thead>
              <tbody>
                {pagedTxns.length === 0 ? (
                  <tr>
                    <td colSpan={9} className="ee-empty ee-center">
                      {txFiltersActive
                        ? 'No transactions match these filters.'
                        : 'No transactions yet.'}
                    </td>
                  </tr>
                ) : (
                  pagedTxns.map((t) => (
                    <tr key={t.transaction_id}>
                      <td className="ee-mono">…{t.transaction_id.slice(-6)}</td>
                      <td>{t.date ?? t.created_at}</td>
                      <td>{t.name_first}</td>
                      <td className="ee-cap">{t.ticket_type.toLowerCase()}</td>
                      <td className="ee-r">{t.admissions}</td>
                      <td className="ee-r ee-strong">{formatToZAR(t.amount_gross)}</td>
                      <td>
                        <span className={`ee-pill ee-pill-${t.payment_status.toLowerCase()}`}>
                          {t.payment_status.toLowerCase()}
                        </span>
                      </td>
                      <td>
                        {t.refund_status !== null ? (
                          <span
                            className={`ee-pill ${
                              t.refund_status === 'pending'
                                ? 'ee-pill-pending'
                                : t.refund_status === 'approved'
                                  ? 'ee-pill-complete'
                                  : 'ee-pill-cancelled'
                            }`}
                          >
                            {t.refund_status}
                          </span>
                        ) : (
                          <span className="ee-muted">None</span>
                        )}
                      </td>
                      <td className="ee-r">{formatToZAR(t.amount_refunded)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="ee-tx-foot">
            <span className="ee-muted">
              Page {txPage} of {txPages}
            </span>
            <div className="ee-tx-foot-actions">
              <button
                type="button"
                className="ee-btn ee-btn-ghost"
                onClick={() => setTxPage((p) => Math.max(p - 1, 1))}
                disabled={txPage === 1}
              >
                Previous
              </button>
              <button
                type="button"
                className="ee-btn ee-btn-ghost"
                onClick={() => setTxPage((p) => Math.min(p + 1, txPages))}
                disabled={txPage === txPages}
              >
                Next
              </button>
              <button
                type="button"
                className="ee-btn ee-btn-dark"
                onClick={() => setTxModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Dialog>

      {errorDisplay === 'block' && (
        <div className={`ee-toast ee-toast-${toastType}`} role="status">
          {String(error)}
        </div>
      )}
    </div>
  )
}

export default Editevent
